<div class="fixed-bottom cookie-notice border-top border-info">
  <div class="container">
    <div class="row align-items-center text-center text-md-start">
      <div class="col-md mb-3 mb-md-0">
        @switch (lang) {
          @default {
            <p>
              Avointen oppimateriaalien kirjasto käyttää vain välttämättömiä evästeitä palvelun käytön
              mahdollistamiseksi. Käyttämämme evästeet ovat istuntokohtaisia tai ne vanhenevat viimeistään 24 tuntia
              käytön jälkeen.
            </p>
          }
          @case ('en') {
            <p>
              The Library of Open Educational Resources uses only necessary cookies to make it possible for you to use
              the service. We use session cookies and cookies that expire 24 hours after using aoe.fi.
            </p>
          }
          @case ('sv') {
            <p>
              Biblioteket för öppna lärresurser använder nödvändiga cookies för att tjänsten fungerar smidigt. Använt
              cookies är session cookies eller dom föråldras efter 24 timmar.
            </p>
          }
        }
      </div>

      <div class="col-md-auto">
        <button type="button" class="btn btn-outline-primary" (click)="cookie.show()">
          {{ "cookies.cookieSettings" | translate }}
        </button>
        <button type="button" class="btn btn-blue" (click)="onSubmit()">{{ "cookies.close" | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #cookie="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="cookie-notice-title">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title float-start" id="cookie-notice-title">{{ "cookies.title" | translate }}</h3>
        <button
          type="button"
          class="btn-close float-end"
          [attr.aria-label]="'forms.common.close' | translate"
          (click)="cookie.hide()"></button>
      </div>

      <div class="modal-body">
        @switch (lang) {
          @default {
            <p>
              Kun vierailet verkkosivustollamme, evästeet tallentavat tiedon vierailustasi. Eväste (cookie) on pieni
              tekstitiedosto, jonka selain tallentaa kävijän laitteelle. Evästeitä on kahta eri päätyyppiä,
              istuntoevästeitä ja pysyviä evästeitä. Istuntoevästeet poistuvat laitteeltasi heti, kun suljet selaimen.
              Pysyvät evästeet säilyvät tallennettuina, kunnes ne erikseen poistetaan tai ne vanhentuvat.
            </p>
            <p>
              Avointen oppimateriaalien kirjasto käyttää istuntoevästeitä ja lyhytikäisiä pysyviä evästeitä turvallisen
              sisäänkirjautumisen takaamiseen. Palvelun pysyvät evästeet vanhentuvat 24 tunnissa.
            </p>
            <p>
              Lain sähköisen viestinnän palveluista (917/2014) mukaisesti tällä sivustolla käytettäviä evästetietoja
              käytetään siten, ettei palvelun käyttäjän yksityisyydensuojaa loukata. Evästetunnistusta ei käytetä
              sivuston kävijän yhdistämiseksi henkilö- tai yhteystietoihin. Evästeitä ei käytetä kävijän päätelaitteen
              tietojen tarkasteluun tai kopiointiin. Evästeitä ei luovuteta kolmansille osapuolille.
            </p>
          }
          @case ('en') {
            <p>
              When you visit our website, cookies record that you visited. A cookie is a small text file that the
              browser stores on the visitor’s device. There are two main types of cookies, session cookies and permanent
              cookies. Session cookies are removed from your device as soon as you close the browser. Permanent cookies
              remain stored until they are specifically removed or they expire.
            </p>
            <p>
              The Library of Open Educational Resources uses session cookies and short-lived cookies to provide secure
              login. All permanent cookies expire after 24 hours.
            </p>
            <p>
              In accordance with the Information Society Code (917/2014), cookie data used on this site is used in such
              a way that the user’s protection of privacy is not violated. Cookie identification is not used to link
              site visitors to personal data or contact details. Cookies are not used for reviewing or copying data on a
              visitor’s terminal device. Cookies are not transferred to third parties.
            </p>
          }
          @case ('sv') {
            <p>
              När du besöker vår webbplats lagrar cookies informationen om ditt besök. En cookie är en liten textfil,
              som webbläsaren lagrar i besökarens apparat. Det finns två huvudtyper av cookies, sessionscookies och
              beständiga cookies. Sessionscookies raderas från din apparat genast när du stänger webbläsaren. Beständiga
              cookies lagras tills de raderas separat eller föråldras.
            </p>
            <p>
              Biblioteket för öppna lärresurser använder session cookies och beständiga cookies för att försäkra dig ett
              säkert inloggning. Alla beständiga cookies åldras efter 24 timmar.
            </p>
            <p>
              Cookieinformationen på den här webbplatsen används i enlighet med lagen om tjänster inom elektronisk
              kommunikation (917/2014) på så att användarens integritet inte kränks. Cookies utnyttjas inte för att
              sammankoppla den som besöker webbplatsen med person- eller kontaktuppgifter. Cookies används inte för att
              granska eller kopiera information i besökarens apparat. Cookies förmedlas inte vidare till tredje parter.
            </p>
          }
        }

        <button type="submit" class="btn btn-blue" (click)="cookie.hide()">{{ "cookies.close" | translate }}</button>
      </div>
    </div>
  </div>
</div>
